<div class="ficha-cadastro-detalhe-cliente-caminhao-proprio-implemento">
  <form [formGroup]="form">
    <div class="form-group pb0">
      <span class="icon pesado-implemento"></span>
      <div class="inputs field-group">
        <label class="ficha-cadastro-detalhe-cliente-caminhao-proprio-implemento_label">Possui implemento rodoviário?</label>
        <div class="switch-row field-group__pesados">
          <div class="switch-group">
            <app-switch
              #simVeiculoImplemento
              id="simVeiculoImplemento"
              (change)="setVeiculoImplemento($event)">
            </app-switch>
            <span class="radio-label">Sim</span>
          </div>

          <div class="switch-group switch-field">
            <app-switch
              #naoVeiculoImplemento
              id="naoVeiculoImplemento"
              (change)="setVeiculoImplemento($event)">
            </app-switch>
            <span class="radio-label">Não</span>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group pb0" [ngClass]="{'dn': !showDadosPreencher}">
      <span class="icon"></span>
        <div class="inputs">
          <label for="marca-veiculo">Marca do Implemento Rodoviário</label>
          <select
            formControlName="veiculoMarca"
            name="marca-veiculo"
            appShowErrorMessages
            [hidden]="!isLoadingMarca"
            class="form-control"
            requiredMessage="O Campo Marca do Implemento Rodoviário é obrigatório"
            (change)="onChangeMarca($event)"
            (blur)="onBlurMarca($event)">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let ma of listaMarca" [ngValue]="ma">{{ ma.descricao }}</option>
          </select>
          <div class="text-danger" *ngIf="!isSelectedMarcaAfterBlur && !isLoadingMarca">Marca do Implemento Rodoviário é obrigatória</div>
          <span *ngIf="isLoadingMarca">
            <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
        </div>
      </div>

      <div class="form-group pb0" [ngClass]="{'dn': !showDadosPreencher}">
        <span class="icon"></span>
        <div class="inputs">
          <label for="ano-veiculo">Ano do Implemento Rodoviário</label>
          <select
            formControlName="veiculoAno"
            name="ano-veiculo"
            [hidden]="!isLoadingAnoModelo"
            requiredMessage="O Campo Ano do Implemento Rodoviário é obrigatório"
            id="vehicle-model-year"
            class="form-control"
            (change)="onChangeAnoModelo($event)"
            appShowErrorMessages
            (blur)="onBlurAnoModelo($event)">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let am of listaAnoModelo" value="{{ am.anoModelo }}">{{ am.anoModelo }}</option>
          </select>
          <div class="text-danger" *ngIf="!isSelectedAnoModeloAfterBlur">Ano do Implemento Rodoviário é obrigatório</div>
          <span *ngIf="isLoadingAnoModelo">
            <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
        </div>
      </div>

      <div class="form-group pb0" [ngClass]="{'dn': !showDadosPreencher}">
        <span class="icon"></span>
        <div class="inputs">
          <label for="modelo-veiculo">Modelo do Implemento Rodoviário</label>
          <select
            formControlName="veiculoModelo"
            name="modelo-veiculo"
            [hidden]="!isLoadingModelo"
            id="vehicle-model"
            requiredMessage="O Campo Modelo do Implemento Rodoviário é obrigatório"
            class="form-control"
            appShowErrorMessages
            (change)="onChangeModelo($event)"
            (blur)="onBlurModelo($event)">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let mo of listaModelo" [ngValue]="mo">{{ mo.descricao }}</option>
          </select>
          <div class="text-danger" *ngIf="!isSelectedModeloAfterBlur">Modelo do Implemento Rodoviário é obrigatório</div>
          <span *ngIf="isLoadingModelo">
            <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i> Carregando...</span>
        </div>
      </div>

  </form>
</div>

<app-modal-message #modalMessage [title]="'Atenção!'"></app-modal-message>
